import * as React from 'react'
import {Editable} from '../Data/Editable'
import ContentClear from 'material-ui/svg-icons/content/clear'
import CircularProgress from 'material-ui/CircularProgress'
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh'
import NavigationCheck from 'material-ui/svg-icons/navigation/check'
import Button from 'material-ui-next/Button'
import injectSheet from 'react-jss'
import {colors, generalStyles} from '../Style'
import {WithClasses} from './Helper'
import ModeEdit from 'material-ui/svg-icons/editor/mode-edit'

const styles = {
    editButton: {
        ...generalStyles.fab,
        ...generalStyles.primaryFab,
    },
    saveButton: {
        ...generalStyles.fab,
        ...generalStyles.primaryFab,
        backgroundColor: colors.success[700],
        '&:hover': {
            backgroundColor: colors.success[900],
        }
    },
    discardButton: {
        ...generalStyles.fab,
        ...generalStyles.secondaryFab,
        backgroundColor: colors.error[700],
        '&:hover': {
            backgroundColor: colors.error[900],
        }
    },
    loadingButton: {
        ...generalStyles.fab,
        ...generalStyles.primaryFab,
    },
    retryButton: {
        ...generalStyles.fab,
        ...generalStyles.primaryFab,
    },
    iconWhite: {
        color: 'white !important',
    },
    iconBlack: {
        color: 'black !important',
    },
}

interface Properties {
    // tslint:disable-next-line no-any
    editable: Editable<any>,
    onEdit: () => void,
    onSave: () => void,
    onDiscard: () => void,
    disabled?: boolean,
}

export const EditableFloatingActionButtons =
    injectSheet<Properties>(styles)(
        ({classes, editable, onEdit, onSave, onDiscard, disabled}: WithClasses<Properties>) => {
            switch (editable.type) {
                case 'Locked':
                    return (
                        <Button
                            fab={true}
                            color="primary"
                            className={classes.editButton}
                            disabled={disabled}
                            onClick={onEdit}
                        >
                            <ModeEdit
                                className={
                                    disabled
                                        ? classes.iconBlack
                                        : classes.iconWhite
                                }
                            />
                        </Button>)
                case 'Pending':
                    return (
                        <div>
                            <Button
                                fab={true}
                                className={classes.saveButton}
                                onClick={onSave}
                            >
                                <NavigationCheck className={classes.iconWhite}/>
                            </Button>
                            <Button
                                fab={true}
                                className={classes.discardButton}
                                onClick={onDiscard}
                            >
                                <ContentClear className={classes.iconWhite}/>
                            </Button>
                        </div>)
                case 'Loading':
                    return (
                        <Button
                            fab={true}
                            className={classes.loadingButton}
                            disabled={true}
                        >
                            <CircularProgress size={24}/>
                        </Button>)
                case 'Failure':
                    return (
                        <div>
                            <Button
                                fab={true}
                                className={classes.retryButton}
                                color="primary"
                                onClick={onSave}
                            >
                                <NavigationRefresh
                                    className={classes.iconWhite}
                                />
                            </Button>
                            <Button
                                fab={true}
                                className={classes.discardButton}
                                onClick={onDiscard}
                            >
                                <ContentClear className={classes.iconWhite}/>
                            </Button>
                        </div>)
            }
        }
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/EditableFloatingActionButtons.tsx